/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useState, useContext } from 'react';
import { useField, useFormikContext, getIn } from 'formik';
import { useLazyQuery } from '@apollo/client';
import { GET_MULTIPLE_PRESIGNED_URLS } from 'pages/Vendor/VendorGraphQL';
import { uploadFileUsingPresignedUrl } from 'helper/utils';
import { Input, Label } from 'reactstrap';
import { toast } from 'react-toastify';
import { axiosPost } from 'services';
import { authContext } from 'contexts/AuthContext';

const S3FileUploadField = ({
  label = false,
  pathUrl,
  multiple = false,
  required = false,
  accept = '',
  disabled = false,
  setLoading = () => {},
  containerName = '',
  onUploadSuccess,
  ...props
}) => {
  const { auth } = useContext(authContext);
  const [field, meta, helpers] = useField(props.name);
  const { submitCount, errors, touched } = useFormikContext() || {};
  const isTouched = getIn(touched, props.name) || meta?.touched;
  const errorMsg = getIn(errors, props.name) || meta?.error;
  const [selectedFiles, setSelectedFiles] = useState([]);

  const generatePreSignedPutUrls = async (urlParamsListDTO) => {
    try {
      const promises = urlParamsListDTO.map((paramRes) => {
        const { data } = paramRes;
        const url = paramRes?.data?.data;
        return axiosPost(
          `${process.env.REACT_APP_REST_API_ENDPOINT}common/generate-presigned-url`,
          { url },
          {},
          auth,
        );
      });
      const preSignedUrlRes = await Promise.all(promises);

      const preSignedUrls = preSignedUrlRes.map((res) => {
        return res?.data?.data;
      });
    } catch (error) {
      console.error('Error generating pre-signed URLs:', error);
    }
  };

  const handleBlur = () => {
    // field.onBlur()
    helpers.setTouched(true);
  };
  const handleFileChange = async (event) => {
    if (disabled) return;
    // let urlParamsListDTO = [];
    setLoading(true);
    const files = event.target?.files;

    if (files && files.length > 0) {
      // Check file size (10 MB = 10 * 1024 * 1024 bytes)
      const maxSize = 10 * 1024 * 1024;
      const fileSize = files[0].size;
      if (fileSize > maxSize) {
        toast.error('File size should not exceed 10 MB.');
        return;
      }

      setSelectedFiles([...files]);
      try {
        // for (const file of files) {
        //   urlParamsListDTO = [
        //     ...urlParamsListDTO,
        //     { contentType: file.type, path: pathUrl, fileName: file.name },
        //   ];
        // }

        const promises = Array.from(files).map((file) => {
          const formData = new FormData();
          formData.append('file', file);
          // Return the axiosPost promise here
          return axiosPost(
            `${process.env.REACT_APP_REST_API_ENDPOINT}common/upload-file${containerName ? `?containerName=${containerName}` : ''}`,
            formData,
            {},
            auth,
          );
        });

        // Wait for all the axiosPost requests to complete
        const urlParamsListDTO = await Promise.all(promises);

        const urls = urlParamsListDTO.map((res) => {
          return res?.data?.data;
        });

        if (multiple) {
          helpers.setValue(urls);
        } else {
          helpers.setValue(urls?.[0]);
        }

        await generatePreSignedPutUrls(urlParamsListDTO);

        if (typeof onUploadSuccess === 'function') {
          await onUploadSuccess(multiple ? urls : urls?.[0]);
        }
      } catch (err) {
        toast.error(err.message);
      } finally {
        setLoading(false);
      }
    }
  };

  // useEffect(() => {
  //   const uploadFiles = async () => {
  //     if (data?.generatePreSignedPutUrls && selectedFiles.length > 0) {
  //       const uploadedFilePaths = [];

  //       const promises = Array.from(selectedFiles).map(async (file, index) => {
  //         try {
  //           // eslint-disable-next-line no-await-in-loop
  //           const response = await uploadFileUsingPresignedUrl(
  //             data.generatePreSignedPutUrls[index],
  //             file,
  //           );

  //           const uploadedFilePath = `${pathUrl}/${file.name}`;
  //           uploadedFilePaths.push(uploadedFilePath);
  //           return uploadedFilePaths;
  //         } catch (err) {
  //           toast.error(err.message);
  //         }
  //       });
  //       await Promise.all(promises);
  //       setLoading(false);
  //       if (multiple) {
  //         helpers.setValue(uploadedFilePaths);
  //       } else {
  //         helpers.setValue(uploadedFilePaths[0]);
  //       }
  //     }
  //   };

  //   uploadFiles();
  // }, [data?.generatePreSignedPutUrls, selectedFiles, helpers]);

  // if (error) return `There is an error on this page : ${error.message} `;

  const shouldShowError =
    (Boolean(isTouched) || Boolean(submitCount && submitCount > 0)) &&
    Boolean(errorMsg);

  return (
    <div className="mb-3">
      {label ? (
        <Label htmlFor={props.name}>
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </Label>
      ) : (
        ''
      )}
      <Input
        type="file"
        id={props.name}
        onBlur={handleBlur}
        onChange={handleFileChange}
        multiple={multiple}
        accept={accept}
        disabled={disabled}
        invalid={Boolean(shouldShowError)}
      />
      {shouldShowError ? (
        <div className="text-danger f-12">{errorMsg}</div>
      ) : null}
    </div>
  );
};

export default S3FileUploadField;
